import * as Yup from 'yup';

export const privilegeSchema = Yup.object().shape({
    name: Yup.string()
        .max(255, 'Name must not exceed 255 characters')
        .required('Name is required'),
    description: Yup.string()
        .max(500, 'Description must not exceed 500 characters')
        .nullable(),
    isParent: Yup.boolean().required(),
    parentId: Yup.string().nullable(),
    menuId: Yup.string().nullable(),
    create_permission: Yup.string().nullable(),
    view_list_permission: Yup.string().nullable(),
    view_detail_permission: Yup.string().nullable(),
    update_permission: Yup.string().nullable(),
    delete_permission: Yup.string().nullable(),
});
